// Tour system configuration.
//
// ALWAYS_FIRST_TIME — when true, tours behave as if it's always the user's
// first visit (ignore "seen" flags). Use during development to keep replaying
// the same tour from a fresh state.
//
// AUTO_LAUNCH_ENABLED — when true, tours configured with `autoLaunchOn.page`
// fire automatically the first time the user lands on that page. When false,
// tours only run when the user explicitly starts them from the Help page.
export const ALWAYS_FIRST_TIME = false;
export const AUTO_LAUNCH_ENABLED = false;
